// @ts-ignore
import styles from './style.module.css';
// @ts-ignore
import React from "react";
// @ts-ignore
import Tooltip from '../../Popups/Tooltip';


interface PaginateData {
  current_page: number;
  last_page: number;
  per_page: number;
  from: number;
  to: number;
  total: number;
}

interface ComponentProps {
  paginateData: PaginateData;
  onPaginate?: any;
  onPaginatePerPage?: any;
  children?: any;
  showOnTop?: boolean;
  showOnBottom?: boolean;
  disabled?: boolean;
}

const AnimalsPaginate = ({ paginateData, onPaginate, onPaginatePerPage, children, showOnTop = true, showOnBottom = true, disabled = false }: ComponentProps) => {
  const [value, setValue] = React.useState(paginateData?.current_page || 1);
  const [perPage, setPerPage] = React.useState(paginateData?.per_page || 10);

  //////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  //////////////////////////////////////////////////////////////////////////////////////
  const callback = (page) => {
    setValue(page);
    if (typeof onPaginate === 'function') onPaginate(page);
  }

  //////////////////////////////////////////////////////////////////////////////////////
  // Handlers
  //////////////////////////////////////////////////////////////////////////////////////

  const handlePagination = (action, page=0) => {
    let current_page = value;
    let last_page = paginateData?.last_page || 1;

    if (last_page === 1) return;
    if (action === 'next-page' && current_page !== last_page) {return callback(current_page+1)};
    if (action === 'prev-page' && current_page !== 1) {return callback(current_page-1)};
    if (action === 'first-page' && current_page !== 1) {return callback(1)};
    if (action === 'last-page' && current_page !== last_page) {return callback(last_page)};
    if (action === 'to-page' && current_page !== page) {return callback(page)};
    return callback(1);
  };

  const handlePaginateButtons = () => {
    let pages:number[] = [];

    for (let i = 1; i <= paginateData?.last_page; i++) {
      pages.push(i)
    }

    return pages
  }

  //////////////////////////////////////////////////////////////////////////////////////
  // Component
  //////////////////////////////////////////////////////////////////////////////////////
  const Pagination = (
    <>
      <div className="d-flex flex-column flex-sm-row mb-2">
        <div className={styles.container}>
          <Tooltip delay={1500} text="Ir para página anterior.">
            <button
              onClick={() => handlePagination("prev-page")}
              disabled={value === 1 || disabled}
            >
              <i className="bi bi-chevron-left"></i>
            </button>
          </Tooltip>
          <>
            {paginateData && handlePaginateButtons().length <= 5 &&
              handlePaginateButtons().map((item) => {
                return (
                  <button 
                    key={item}
                    className={paginateData.current_page==item?styles.actual:null}
                    onClick={(e) => {handlePagination("to-page", item)}}
                  >{item}</button>
                )
              })
            } 
            {paginateData && handlePaginateButtons().length > 5 && (
              <>
                <button
                  key={1}
                  className={paginateData.current_page==1?styles.actual:null}
                  onClick={(e) => {handlePagination("to-page", 1)}}
                >1</button>
                {paginateData.current_page<=2 && (
                  <button
                    key={2}
                    className={paginateData.current_page==2?styles.actual:null}
                    onClick={(e) => {handlePagination("to-page", 2)}}
                  >2</button>
                )}
                {paginateData.current_page>2 && paginateData.current_page<paginateData.last_page-1 && (
                  <button
                    key={paginateData.current_page}
                    className={paginateData.current_page==paginateData.current_page?styles.actual:null}
                    onClick={(e) => {handlePagination("to-page", paginateData.current_page)}}
                  >{paginateData.current_page}</button>
                )}
                {paginateData.current_page>=paginateData.last_page-1 && (
                  <button
                    key={paginateData.last_page-1}
                    className={paginateData.current_page==paginateData.last_page-1?styles.actual:null}
                    onClick={(e) => {handlePagination("to-page", paginateData.last_page-1)}}
                  >{paginateData.last_page-1}</button>
                )}
                <button
                  key={paginateData.last_page}
                  className={paginateData.current_page==paginateData.last_page?styles.actual:null}
                  onClick={(e) => {handlePagination("to-page", paginateData.last_page)}}
                >{paginateData.last_page}</button>
              </>
            )}
          </>
          <Tooltip delay={1500} text="Ir para próxima página.">
            <button
              onClick={() => handlePagination("next-page")}
              disabled={value === (paginateData?.last_page || 1) || disabled}
            >
              <i className="bi bi-chevron-right"></i>
            </button>
          </Tooltip>
        </div>
      </div>
    </>
  );

  //////////////////////////////////////////////////////////////////////////////////////
  // Render
  //////////////////////////////////////////////////////////////////////////////////////
  return (<>
    {showOnTop && Pagination}
    {children}
    {showOnBottom && Pagination}
  </>);
};

export default AnimalsPaginate;